export const FLAG_GETTING_DRIVERS_MOVEMENT = 'FLAG_GETTING_DRIVERS_MOVEMENT';
export const GET_DRIVERS_MOVEMENT = 'GET_DRIVERS_MOVEMENT';
export const CLEAR_DRIVERS_MOVEMENT = 'CLEAR_DRIVERS_MOVEMENT';
export const FLAG_DRIVER_MOVEMENT_ACTIVITY = 'FLAG_DRIVER_MOVEMENT_ACTIVITY';
export const GET_DRIVER_MOVEMENT = 'GET_DRIVER_MOVEMENT';
export const CLEAR_DRIVER_MOVEMENT = 'CLEAR_DRIVER_MOVEMENT';
